import { createFileRoute } from '@tanstack/react-router';
import { SeoKeywordMapPage } from '@/pages/SeoKeywordMapPage';

export const Route = createFileRoute('/_authed/seo/keyword-map')({
  component: SeoKeywordMapPage,
});
